// Permission strings generated by AccessMatrixGen from the features added in core PR C3 (spec 7.2 places them in C4; C3 moved them)
// (spec 7.2). Marketing_AdApprovalsViaMcp is MCP-only and never checked in the web UI.
export const ADS_PERMISSIONS = {
  read: 'marketing.ads.read',
  approve: 'marketing.ad_approvals.write',
  admin: 'marketing.ad_approvals.admin',
} as const;
